/* DDUDDI product-detail JS (Matin Kim match) loaded via footer-group dd_css */
(function () {
  function locale() {
    var l = (document.documentElement.lang || '').toLowerCase();
    if (l.indexOf('ko') === 0) return 'ko';
    if (l.indexOf('ja') === 0) return 'ja';
    return 'en';
  }
  function isKo() {
    return locale() === 'ko';
  }

  function colorHex(name) {
    var n = (name || '').toLowerCase();
    function has() { for (var i = 0; i < arguments.length; i++) { if (n.indexOf(arguments[i]) >= 0) return true; } return false; }
    if (has('블랙', 'black')) return '#1e1e1e';
    if (has('차콜', 'charcoal')) return '#3c3c3c';
    if (has('네이비', 'navy')) return '#26324d';
    if (has('인디고', 'indigo')) return '#3b4a6b';
    if (has('버건디', '베리', 'berry')) return '#6e2233';
    if (has('레드', 'red', '빨강')) return '#cf4040';
    if (has('멜란지블루', '메란지블루')) return '#8a99b5';
    if (has('스카이브라운', '브라운', '초콜', '커피', 'brown', '갈색', 'coffee')) return '#6b4a2f';
    if (has('소라', '스카이', '하늘', '연블루', '클라우드블루', 'sky', 'sora')) return '#a9c7e8';
    if (has('블루', 'blue')) return '#9cbfe6';
    if (has('민트', 'mint')) return '#bfe3d0';
    if (has('치카', '올리브', 'olive', 'khaki', '카키')) return '#7e7c50';
    if (has('머스타드', 'mustard')) return '#c2a24d';
    if (has('그린', '빈티지그린', 'green')) return '#9bb894';
    if (has('연두')) return '#c3d98c';
    if (has('보라', '바이올렛', '연보라', '포도', '퍼플', 'purple', 'violet', 'grape')) return '#b39ddb';
    if (has('연핑크', '라이트핑크', '분홍')) return '#f8d0dc';
    if (has('로즈', 'rose', '뉴핑크', '핑크스틸')) return '#e0a3ab';
    if (has('핑크', 'pink')) return '#f6b8ce';
    if (has('코랄', 'coral')) return '#f2a488';
    if (has('피치', '복숭아', 'peach')) return '#f6c1a6';
    if (has('멜론', 'melon')) return '#f9cf9a';
    if (has('탠저린', '텐저린', '오렌지', 'tangerine', 'orange')) return '#f0995a';
    if (has('레몬', '라임', '노랑', '옐로우', '병아리', '선플라워', 'yellow', 'lemon', 'lime')) return '#f3df6b';
    if (has('버터', '바닐라', 'butter')) return '#f2e7b8';
    if (has('크림', 'cream')) return '#f3ecd2';
    if (has('아이보리', 'ivory')) return '#f4efe2';
    if (has('오트밀', '샌드', '베이지', '코지', 'beige', 'sand', 'oatmeal')) return '#dcc9a8';
    if (has('멜란지그레이', '메란지그레이', '그레이', '화이트메란지', 'gray', 'grey')) return '#9e9e9e';
    if (has('화이트', 'white', '내츄럴', '내추럴')) return '#efeae0';
    return '#dddddd';
  }
  var COLOR_EN = {
    '그레이': 'GREY', '노랑': 'YELLOW', '라이트베이지': 'LIGHT BEIGE', '라이트블루': 'LIGHT BLUE',
    '라이트오렌지': 'LIGHT ORANGE', '라이트올리브': 'LIGHT OLIVE', '라이트핑크': 'LIGHT PINK',
    '라일락': 'LILAC', '라임': 'LIME', '레드': 'RED', '레몬': 'LEMON', '멜론': 'MELON',
    '민트': 'MINT', '민트그레이': 'MINT GREY', '바이올렛': 'VIOLET', '버터': 'BUTTER',
    '베이지': 'BEIGE', '브라운(뉴컬러)': 'BROWN (NEW)', '블랙': 'BLACK', '블루': 'BLUE',
    '블루(뉴컬러)': 'BLUE (NEW)', '살구': 'APRICOT', '새싹': 'SPROUT', '세이지민트': 'SAGE MINT',
    '스무디핑크': 'SMOOTHIE PINK', '씨블루': 'SEA BLUE', '아이보리': 'IVORY', '아이스블루': 'ICE BLUE',
    '연노랑': 'LIGHT YELLOW', '연두': 'LIGHT GREEN', '오렌지': 'ORANGE', '인디핑크': 'INDIE PINK',
    '카멜': 'CAMEL', '플라워': 'FLOWER', '핑크': 'PINK', '화이트멜란지': 'WHITE MELANGE'
  };
  var COLOR_JA = {
    '그레이': 'グレー', '노랑': 'イエロー', '라이트베이지': 'ライトベージュ', '라이트블루': 'ライトブルー',
    '라이트오렌지': 'ライトオレンジ', '라이트올리브': 'ライトオリーブ', '라이트핑크': 'ライトピンク',
    '라일락': 'ライラック', '라임': 'ライム', '레드': 'レッド', '레몬': 'レモン', '멜론': 'メロン',
    '민트': 'ミント', '민트그레이': 'ミントグレー', '바이올렛': 'バイオレット', '버터': 'バター',
    '베이지': 'ベージュ', '브라운(뉴컬러)': 'ブラウン(新色)', '블랙': 'ブラック', '블루': 'ブルー',
    '블루(뉴컬러)': 'ブルー(新色)', '살구': 'アプリコット', '새싹': 'スプラウト', '세이지민트': 'セージミント',
    '스무디핑크': 'スムージーピンク', '씨블루': 'シーブルー', '아이보리': 'アイボリー', '아이스블루': 'アイスブルー',
    '연노랑': 'ライトイエロー', '연두': 'ライトグリーン', '오렌지': 'オレンジ', '인디핑크': 'インディーピンク',
    '카멜': 'キャメル', '플라워': 'フラワー', '핑크': 'ピンク', '화이트멜란지': 'ホワイトメランジ'
  };
  function enColor(name) {
    var v = (name || '').trim();
    if (!v) return '';
    if (COLOR_EN[v]) return COLOR_EN[v];
    if (!/[가-힣]/.test(v)) return v.toUpperCase();
    return v;
  }
  function jaColor(name) {
    var v = (name || '').trim();
    if (!v) return '';
    if (COLOR_JA[v]) return COLOR_JA[v];
    return v;
  }
  function localizeColor(name, lc) {
    return lc === 'ja' ? jaColor(name) : enColor(name);
  }
  function enSize(s) {
    return (s || '').replace(/무료/g, 'FREE').replace(/토들러/g, 'TODDLER').replace(/베이비/g, 'BABY');
  }
  function jaSize(s) {
    return (s || '').replace(/무료/g, 'フリー').replace(/토들러/g, 'トドラー').replace(/베이비/g, 'ベビー');
  }
  function sizeLabels() {
    var lc = locale();
    if (lc === 'ko') return;
    if (!document.querySelector('.product')) return;
    var convert = lc === 'ja' ? jaSize : enSize;
    function walk(el) {
      for (var i = 0; i < el.childNodes.length; i++) {
        var n = el.childNodes[i];
        if (n.nodeType === 3) { var t = n.textContent, e = convert(t); if (e !== t) n.textContent = e; }
        else if (n.nodeType === 1) walk(n);
      }
    }
    [].forEach.call(document.querySelectorAll('.product .product-form__input label, .product .product-form__input option'), walk);
  }
  function labelEnglish() {
    var lc = locale();
    if (lc === 'ko') return;
    if (!document.querySelector('.product')) return;
    var sizeLabel = lc === 'ja' ? 'サイズ' : 'SIZE';
    var colorLabel = lc === 'ja' ? 'カラー' : 'COLOR';
    var labels = [].slice.call(document.querySelectorAll('.product .product-form__input legend.form__label, .product .product-form__input .form__label'));
    labels.forEach(function (l) {
      var tn = null;
      for (var i = 0; i < l.childNodes.length; i++) {
        if (l.childNodes[i].nodeType === 3 && l.childNodes[i].textContent.trim()) { tn = l.childNodes[i]; break; }
      }
      var t = (tn ? tn.textContent : l.textContent).trim();
      if (/^사이즈|^サイズ/.test(t)) { if (tn) tn.textContent = sizeLabel; else l.textContent = sizeLabel; }
      else if (/^컬러|^색상|^カラー/.test(t)) { if (tn) tn.textContent = colorLabel; else l.textContent = colorLabel; }
    });
  }

  function colorSwatches() {
    if (!document.querySelector('.product')) return;
    var lc = locale();
    var ko = lc === 'ko';
    var colorLabel = lc === 'ja' ? 'カラー' : 'COLOR';
    var groups = [].slice.call(document.querySelectorAll('.product .product-form__input--pill'));
    groups.forEach(function (g) {
      var legend = g.querySelector('legend');
      if (!legend || !/컬러|colou?r|색상|SIZE|COLOR|カラー/i.test(legend.textContent)) return;
      if (g.classList.contains('dd-colorgroup')) return;
      if (/^\s*(size)|사이즈|サイズ/i.test((legend.textContent || '').trim())) return;
      var legendText = (legend.textContent || '').trim();
      g.classList.add('dd-colorgroup');
      var head = document.createElement('div');
      head.className = 'dd-color-head';
      var lab = document.createElement('span');
      lab.className = 'dd-color-lab';
      lab.textContent = ko ? legendText : colorLabel;
      var nameEl = document.createElement('span');
      nameEl.className = 'dd-color-name';
      head.appendChild(lab);
      head.appendChild(nameEl);
      g.insertBefore(head, legend.nextSibling);
      [].slice.call(g.querySelectorAll('input[type=radio]')).forEach(function (inp) {
        var l = inp.nextElementSibling;
        if (!l) return;
        var val = (inp.value || l.textContent || '').trim();
        l.style.setProperty('background', colorHex(val), 'important');
        l.setAttribute('title', ko ? val : localizeColor(val, lc));
        l.setAttribute('data-name', val);
      });
      function upd() {
        var c = g.querySelector('input:checked');
        var val = c ? (c.value || '').trim() : '';
        nameEl.textContent = val ? (ko ? val : localizeColor(val, lc)) : '';
      }
      g.addEventListener('change', upd);
      upd();
    });
  }

  function swatchColorHeader() {
    if (!document.querySelector('.product')) return;
    var lc = locale();
    var ko = lc === 'ko';
    var colorLabel = lc === 'ja' ? 'カラー' : 'COLOR';
    var groups = document.querySelectorAll('.product .product-form__input--swatch');
    [].forEach.call(groups, function (g) {
      var lg = g.querySelector('legend');
      if (!lg || !/컬러|colou?r|색상|COLOR|カラー/i.test(lg.textContent)) return;
      lg.classList.add('dd-swatch-legend');
      if (!ko) {
        for (var i = 0; i < lg.childNodes.length; i++) {
          var n = lg.childNodes[i];
          if (n.nodeType === 3 && n.textContent.trim()) { n.textContent = colorLabel; break; }
        }
      }
      var span = lg.querySelector('[data-selected-value]') || lg.querySelector('span');
      if (span && !ko) { var loc = localizeColor(span.textContent.trim(), lc); if (loc) span.textContent = loc; }
      if (ko) return;
      [].forEach.call(g.querySelectorAll('input[type=radio]'), function (inp) {
        var l = inp.nextElementSibling;
        if (!l) return;
        var val = (inp.value || l.getAttribute('title') || '').trim();
        var out = localizeColor(val, lc);
        if (!out) return;
        l.setAttribute('title', out);
        var vh = l.querySelector('.visually-hidden:not(.label-unavailable)');
        if (vh) vh.textContent = out;
      });
    });
  }

  function englishButtons() {
    var lc = locale();
    if (lc === 'ko') return;
    if (!document.querySelector('.product')) return;
    var ja = lc === 'ja';
    var ADD = ja ? 'カートに入れる' : 'ADD TO BAG';
    var SOLD = ja ? '売り切れ' : 'SOLD OUT';
    var UNAVAILABLE = ja ? '購入不可' : 'UNAVAILABLE';
    if (window.variantStrings) {
      window.variantStrings.addToCart = ADD;
      window.variantStrings.soldOut = SOLD;
      window.variantStrings.unavailable = UNAVAILABLE;
    }
    var submit = document.querySelector('.product .product-form__submit');
    if (submit) {
      var span = submit.querySelector('span');
      if (span) {
        if (submit.disabled) { if (/품절|sold/i.test(span.textContent)) span.textContent = SOLD; }
        else { span.textContent = ADD; }
      }
    }
  }

  function payLabel() {
    var lc = locale();
    if (lc === 'ko') return;
    var label = lc === 'ja' ? '今すぐ購入' : 'BUY IT NOW';
    var btn = document.querySelector('.product .shopify-payment-button__button');
    if (!btn) return;
    var t = (btn.textContent || '').trim();
    if (t && t !== label && btn.children.length === 0) { btn.textContent = label; }
    var wrap = document.querySelector('.product .shopify-payment-button');
    if (wrap && !wrap.getAttribute('data-dd-obs')) {
      wrap.setAttribute('data-dd-obs', '1');
      new MutationObserver(function () { payLabel(); }).observe(wrap, { subtree: true, childList: true, characterData: true });
    }
  }

  function wishlistLink() {
    if (!document.querySelector('.product')) return;
    var buttons = document.querySelector('.product .product-form__buttons');
    if (!buttons || document.querySelector('.product .dd-wishlink')) return;
    var label = locale() === 'ja' ? 'ウィッシュリストに追加' : 'Add to Wishlist';
    var a = document.createElement('a');
    a.href = '/account';
    a.className = 'dd-wishlink';
    a.innerHTML = '<span aria-hidden="true"><svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M10 16.6S3.7 12.9 3.7 8.4A3.15 3.15 0 0110 6.85 3.15 3.15 0 0116.3 8.4c0 4.5-6.3 8.2-6.3 8.2z"></path></svg></span><span>' + label + '</span>';
    buttons.parentNode.insertBefore(a, buttons.nextSibling);
  }

  function convertTabs() {
    if (!document.querySelector('.product')) return;
    if (document.querySelector('.product .dd-tabs')) return;
    var accs = [].slice.call(document.querySelectorAll('.product .product__accordion')).filter(function (a) { return a.querySelector('summary'); });
    var desc = document.querySelector('.product .product__description');
    if (!accs.length && !desc) return;
    var sizeC = null, deliveryC = null;
    accs.forEach(function (a) {
      var te = a.querySelector('.accordion__title') || a.querySelector('summary');
      var t = (te ? te.textContent : '').toUpperCase();
      var c = a.querySelector('.accordion__content') || a.querySelector('.rte');
      if (/SIZE|사이즈/.test(t)) sizeC = c;
      else if (/SHIP|DELIV|RETURN|배송|교환|반품/.test(t)) deliveryC = c;
      else if (!deliveryC) deliveryC = c;
    });
    var items = [];
    if (desc) items.push({ label: 'PRODUCT', node: desc });
    if (sizeC) items.push({ label: 'SIZE GUIDE', node: sizeC });
    if (deliveryC) items.push({ label: 'DELIVERY', node: deliveryC });
    if (!items.length) return;
    var anchor = accs[0] || desc;
    var wrap = document.createElement('div'); wrap.className = 'dd-tabs';
    var bar = document.createElement('div'); bar.className = 'dd-tabbar';
    var panels = document.createElement('div'); panels.className = 'dd-tabpanels';
    anchor.parentNode.insertBefore(wrap, anchor);
    wrap.appendChild(bar);
    wrap.appendChild(panels);
    items.forEach(function (it, i) {
      var tab = document.createElement('button');
      tab.type = 'button'; tab.className = 'dd-tab'; tab.setAttribute('data-i', i); tab.textContent = it.label;
      bar.appendChild(tab);
      var panel = document.createElement('div'); panel.className = 'dd-tabpanel';
      if (it.node) panel.appendChild(it.node);
      panels.appendChild(panel);
    });
    accs.forEach(function (a) { if (a.parentNode) a.parentNode.removeChild(a); });
    function show(i) {
      [].forEach.call(bar.children, function (b, j) { b.classList.toggle('is-on', j === i); });
      [].forEach.call(panels.children, function (p, j) { p.style.display = (j === i) ? 'block' : 'none'; });
    }
    bar.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.dd-tab') : null;
      if (!b) return;
      show(parseInt(b.getAttribute('data-i'), 10));
    });
    show(0);
  }

  /* Some products have sparse variant matrices (e.g. 테두리디자인 x 컬러 where only
     some colors exist per edge design). Switching the first option can leave a
     stale, now-invalid value selected in a later option, so no variant matches:
     price disappears and the buy button goes "UNAVAILABLE" with no explanation.
     When that happens, auto-correct the later option(s) to the first value that
     IS available for the option the shopper just changed. */
  function invalidComboFix() {
    if (!document.querySelector('.product')) return;
    var vs = document.querySelector('.product variant-selects');
    if (!vs || vs.getAttribute('data-dd-combo')) return;
    vs.setAttribute('data-dd-combo', '1');
    var cache = null;
    function loadVariants(cb) {
      if (cache) { cb(cache); return; }
      var handle = vs.getAttribute('data-product-handle');
      if (!handle) { cb(null); return; }
      var prefix = location.pathname.split('/products/')[0]; /* keep locale prefix, e.g. /ko */
      fetch(prefix + '/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { cache = p.variants; cb(cache); })
        .catch(function () { cb(null); });
    }
    function fieldsets() { return [].slice.call(vs.querySelectorAll('fieldset')); }
    function selectValue(fs, value) {
      var input = [].filter.call(fs.querySelectorAll('input[type=radio]'), function (i) { return i.value === value; })[0];
      if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    vs.addEventListener('change', function (e) {
      var changedFieldset = e.target.closest('fieldset');
      var fs = fieldsets();
      var changedIndex = fs.indexOf(changedFieldset);
      if (changedIndex === -1) return;
      window.setTimeout(function () {
        var submit = document.querySelector('.product-form__submit');
        if (!submit || !submit.disabled) return;
        loadVariants(function (variants) {
          if (!variants) return;
          var changedVal = e.target.value;

          /* Prefer a variant that keeps every OTHER currently-selected option
             (e.g. colour) as-is and only resolves the option that actually
             changed. Without this, any spurious/stale "submit disabled" read
             (a timing race with Dawn's own fetch, not a real invalid combo -
             e.g. picking a size, which is independent of colour) fell back
             straight to the first variant for the changed value, silently
             resetting colour to whatever variant happened to be first. */
          var currentVals = fs.map(function (f) {
            var checked = f.querySelector('input:checked');
            return checked ? checked.value : null;
          });
          currentVals[changedIndex] = changedVal;

          var match = variants.filter(function (v) {
            var opts = [v.option1, v.option2, v.option3];
            if (!v.available || opts[changedIndex] !== changedVal) return false;
            for (var i = 0; i < currentVals.length; i++) {
              if (i === changedIndex || currentVals[i] == null) continue;
              if (opts[i] !== currentVals[i]) return false;
            }
            return true;
          })[0];

          /* No variant preserves the rest of the selection - a genuinely
             sparse matrix (e.g. edge design x colour). Fall back to the
             first available variant for the changed value, same as before. */
          if (!match) {
            match = variants.filter(function (v) {
              var opts = [v.option1, v.option2, v.option3];
              return v.available && opts[changedIndex] === changedVal;
            })[0];
          }
          if (!match) return;
          [match.option1, match.option2, match.option3].forEach(function (val, i) {
            if (i === changedIndex || val == null || !fs[i]) return;
            selectValue(fs[i], val);
          });
        });
      }, 450);
    });
  }

  /* SIZE (and similar) pill groups with many options wrap to a 2nd line via
     flex-wrap, but plain wrapping fills row 1 greedily and dumps whatever's
     left onto row 2 (e.g. 7 on top, 1 alone on the bottom) - lopsided and
     ugly. When a group genuinely doesn't fit on one line, split it evenly
     into exactly 2 rows instead (e.g. 8 options -> 4 + 4) via CSS grid with
     ceil(count/2) columns. Groups that DO fit on one line are left as a
     normal single-row flex layout untouched.

     ddApply() re-runs this on every variant change, and ddSchedule() fires
     it up to 7 times per change - re-measuring every time forces the group
     through remove-grid -> flex -> re-add-grid on each call, which visibly
     snaps the row count back and forth and shoves the content below it.
     Cache the last measurement (label count + container width) and skip
     entirely when neither has changed, so repeat calls are a no-op instead
     of a layout thrash. */
  function pillGridSplit() {
    if (!document.querySelector('.product')) return;
    var groups = [].slice.call(document.querySelectorAll('.product .product-form__input--pill:not(.dd-colorgroup)'));
    groups.forEach(function (g) {
      var labels = [].slice.call(g.querySelectorAll('input[type=radio]')).map(function (inp) { return inp.nextElementSibling; }).filter(Boolean);
      if (labels.length < 3) return; /* 2 or fewer never needs a 2-row split */

      var sig = labels.length + '|' + g.clientWidth;
      if (g.__ddGridSig === sig) return; /* nothing relevant changed since last measurement */

      /* reset to single-row flex to get a clean measurement */
      g.classList.remove('dd-pill-grid');
      g.style.removeProperty('grid-template-columns');
      labels.forEach(function (l) { l.style.setProperty('flex', '0 0 auto', 'important'); l.style.setProperty('width', 'auto', 'important'); });

      var naturalSum = labels.reduce(function (sum, l) { return sum + l.getBoundingClientRect().width; }, 0);
      var gapPx = parseFloat(getComputedStyle(g).columnGap || getComputedStyle(g).gap || '0') || 0;
      naturalSum += gapPx * (labels.length - 1);
      var available = g.clientWidth;

      labels.forEach(function (l) { l.style.removeProperty('flex'); l.style.removeProperty('width'); });

      if (naturalSum > available + 1) {
        var cols = Math.ceil(labels.length / 2);
        g.classList.add('dd-pill-grid');
        g.style.gridTemplateColumns = 'repeat(' + cols + ', 1fr)';
      }
      g.__ddGridSig = sig;
    });
  }
  var pillGridResizeWired = false;
  function wirePillGridResize() {
    if (pillGridResizeWired) return;
    pillGridResizeWired = true;
    var t;
    window.addEventListener('resize', function () {
      window.clearTimeout(t);
      t = window.setTimeout(pillGridSplit, 150);
    });
  }

  /* Dawn's media-gallery.js setActiveMedia() is built for a slider that shows
     one image at a time: on a color swatch change it PREPENDS the matching
     image to the front of the list, then scrolls the page to it. This
     product page instead stacks every image vertically and shows them all
     at once (see dduddi-product.css), so that reorder reshuffles the
     whole stack on every click - and because the scroll position is
     computed against the list AFTER the reorder, it frequently lands on the
     wrong (now-shifted) image. Replace it with a version that only marks
     the matching image active and scrolls to it, without ever reordering
     the DOM. */
  function patchGalleryScroll() {
    var MediaGalleryEl = window.customElements && customElements.get('media-gallery');
    if (!MediaGalleryEl || MediaGalleryEl.__ddPatched) return;
    MediaGalleryEl.__ddPatched = true;
    MediaGalleryEl.prototype.setActiveMedia = function (mediaId, prepend) {
      var activeMedia =
        this.elements.viewer.querySelector('[data-media-id="' + mediaId + '"]') ||
        this.elements.viewer.querySelector('[data-media-id]');
      if (!activeMedia) return;
      [].forEach.call(this.elements.viewer.querySelectorAll('[data-media-id]'), function (el) {
        el.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      this.preventStickyHeader();
      window.setTimeout(function () {
        activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 30);
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      var activeThumbnail = this.elements.thumbnails.querySelector('[data-target="' + mediaId + '"]');
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    };
  }

  /* Combined-listing test: products carrying a custom.color_group metafield
     (see templates/product.json block "dd_color_group") emit a JSON island
     of {self, group} sibling products that share one style. Render a color
     swatch bar from that data and, on click, swap the whole .product element
     for the target product's own rendered markup via Section Rendering API
     (no full page reload), Matin Kim style. No-ops entirely for every
     product without that metafield, so it never touches the existing catalog.

     Swatch order is pinned by numeric product ID (ascending) rather than
     "self first" - self-first made the row reshuffle on every color click
     since whichever product you're on always led, which read as random. A
     fixed ID-based order stays visually identical no matter which color's
     page you're viewing, matching how the color products were created. */
  function crossProductSwatches() {
    var dataEl = document.getElementById('dd-color-group-data');
    var mount = document.getElementById('dd-color-group-swatches');
    if (!dataEl || !mount || mount.__ddWired) return;
    mount.__ddWired = true;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data || !data.self) return;
    var lc = locale();
    var ko = lc === 'ko';
    var colorLabel = lc === 'ja' ? 'カラー' : 'COLOR';

    mount.className = 'dd-colorgroup';
    var head = document.createElement('div');
    head.className = 'dd-color-head';
    var lab = document.createElement('span');
    lab.className = 'dd-color-lab';
    lab.textContent = ko ? '컬러' : colorLabel;
    var nameEl = document.createElement('span');
    nameEl.className = 'dd-color-name';
    nameEl.textContent = ko ? data.self.color : localizeColor(data.self.color, lc);
    head.appendChild(lab);
    head.appendChild(nameEl);
    mount.appendChild(head);

    function idNum(item) {
      var m = /(\d+)$/.exec(item.id || '');
      return m ? parseInt(m[1], 10) : 0;
    }
    var items = [data.self].concat(data.group || []);
    items.sort(function (a, b) { return idNum(a) - idNum(b); });

    items.forEach(function (item) {
      var isSelf = item.id === data.self.id;
      var a = document.createElement('a');
      a.href = item.url;
      a.title = ko ? item.color : localizeColor(item.color, lc);
      a.style.cssText = 'display:inline-block;width:2.2rem;height:2.2rem;min-width:2.2rem;border-radius:50%;border:1px solid #ddd;background-clip:padding-box;';
      a.style.setProperty('background', item.hex || colorHex(item.color), 'important');
      if (isSelf) {
        a.style.borderColor = '#1e1e1e';
        a.style.boxShadow = '0 0 0 2px #fff inset, 0 0 0 1px #1e1e1e';
      }
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (isSelf) return;
        swapToProduct(item.url);
      });
      mount.appendChild(a);
    });
  }

  function swapToProduct(url) {
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    fetch(url + sep + 'section_id=main')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newProduct = doc.querySelector('.product');
        var oldProduct = document.querySelector('.product');
        if (!newProduct || !oldProduct) { window.location.href = url; return; }
        oldProduct.replaceWith(newProduct);
        window.history.pushState({ ddSwap: true }, '', url);
        var titleEl = newProduct.querySelector('.product__title');
        if (titleEl) document.title = titleEl.textContent.trim();
        window.scrollTo(0, 0);
        ddSchedule();
      })
      .catch(function () { window.location.href = url; });
  }

  function ddApply() {
    labelEnglish();
    sizeLabels();
    colorSwatches();
    swatchColorHeader();
    englishButtons();
    payLabel();
    wishlistLink();
    convertTabs();
    invalidComboFix();
    pillGridSplit();
    wirePillGridResize();
    patchGalleryScroll();
    crossProductSwatches();
  }

  function ddSchedule() {
    [0, 80, 200, 400, 700, 1100, 1600].forEach(function (d) { window.setTimeout(ddApply, d); });
  }

  window.addEventListener('load', function () {
    if (!document.querySelector('.product')) return;
    ddApply();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product')) ddSchedule();
    }, true);
  });

  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.ddSwap) window.location.reload();
  });
})();
